import type { ICategoryComparison } from "app/pages/industry-analysis/categories-context/CategoriesContext";

import { processGenderDistributionData } from "../utils/dataProcessors";

import { useDemographicsComparisonData } from "./useDemographicsComparisonData";

export function useDemographicsGenderDistributionComparisonData(categories: ICategoryComparison[]) {
    return useDemographicsComparisonData({
        categories,
        select: (data) => processGenderDistributionData(data?.GenderRatios),
    });
}
